import React from 'react';
import ReactGA from 'react-ga';
import _ from 'lodash';
import { getCurrentPage } from '../helpers';

import RouteSummary from './RouteSummary';
import TurnByTurn from './TurnByTurn';
import Footer from './Footer';



class Results extends React.Component {

	// Switch current journey type on tab click
	handleTab = (type) => {

		// GA Track
		ReactGA.event({
			category: _.startCase(getCurrentPage()),
			action: 'Click on Balanced/Quietest/Fastest/Ebike',
			label: type,
		});

		this.props.setCurrent(type);
	}

	updateMap = () => {

		// Store the currently selected journey type, with "balanced" as a default
		const current = this.props.currentJourney.currentJourney || 'balanced';

		// Plot the polylines for the current route (assembled in cycleStreets service)
		if (this.props.cycleRoutes[current]) {

			this.props.addPolylines('routes', this.props.cycleRoutes[current].polylines);
		}
	}

	componentDidMount() {

		this.updateMap();
	}

	componentDidUpdate(prevProps) {

		// New journey
		const newJourney = !_.isEqual(this.props.currentJourney, prevProps.currentJourney);

		if (newJourney) {
			this.updateMap();
		}
	}

	render() {

		const endIndex = this.props.locations.length - 1;

		return (

			<div className="cycle-routes-results">

				<ul className="locations-start-finish">
					<li>
						<span>From: </span>{ this.props.locations[0].name }
					</li>
					<li>
						<span>To: </span>{ this.props.locations[endIndex].name }
					</li>
				</ul>

				<div className={ `tabs ${ this.props.currentJourney.currentJourney }-active results-tabs` }>
					<button className="tab" onClick={ (e) => { e.preventDefault(); this.handleTab('balanced'); } }>Balanced</button>
					<button className="tab" onClick={ (e) => { e.preventDefault(); this.handleTab('quietest'); } }>Quietest</button>
					<button className="tab" onClick={ (e) => { e.preventDefault(); this.handleTab('fastest'); } }>Fastest</button>
					<button className="tab" onClick={ (e) => { e.preventDefault(); this.handleTab('ebike'); } }>Ebike</button>
				</div>

				<RouteSummary { ...this.props } />

				<TurnByTurn { ...this.props } />

				<Footer />

			</div>

		)
	}
}

export default Results;



// WEBPACK FOOTER //
// ./src/components/Results.js